import React from 'react'
import PropTypes from 'prop-types'

export const ErrorType = PropTypes.oneOfType([
    PropTypes.instanceOf(Error),
    PropTypes.shape({
        message: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        stack: PropTypes.string
    })
])
